<template>
  <default-template-message class="mb30">
    <div class="default-email-message-template">
      <div class="default-email-message-template__section">
        <email-message-template-text-area
          class="default-email-message-template__title"
          field-name="greeting"
          :value="templateData.greeting"
          :max-length="fieldsMaxLength.greeting"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />

        <email-message-template-text-area
          class="default-email-message-template__paragraph"
          field-name="bodyPartOne"
          :value="templateData.bodyPartOne"
          :max-length="fieldsMaxLength.bodyPartOne"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />
        <email-message-template-text-area
          class="default-email-message-template__paragraph"
          field-name="bodyPartTwo"
          :value="templateData.bodyPartTwo"
          :max-length="fieldsMaxLength.bodyPartTwo"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />
        <email-message-template-text-area
          class="default-email-message-template__paragraph"
          field-name="bodyPartThree"
          :value="templateData.bodyPartThree"
          :max-length="fieldsMaxLength.bodyPartThree"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />
        <email-message-template-text-area
          class="default-email-message-template__paragraph"
          field-name="bodyPartFour"
          :value="templateData.bodyPartFour"
          :max-length="fieldsMaxLength.bodyPartFour"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />
      </div>

      <slot name="treatment-details"></slot>

      <email-message-template-link-section :link-name="templateData.linkName" />

      <email-message-template-signature-section :template-data="templateData" />
    </div>
  </default-template-message>
</template>

<script>
import DefaultTemplateMessage from '@/modules/dashboard/components/message-templates/common/DefaultTemplateMessage';
import EmailMessageTemplateTextArea from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextArea';
import EmailMessageTemplateSignatureSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateSignatureSection';
import EmailMessageTemplateLinkSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateLinkSection';

export default {
  name: 'ReminderOfferEmailTemplate',
  components: {
    DefaultTemplateMessage,
    EmailMessageTemplateTextArea,
    EmailMessageTemplateSignatureSection,
    EmailMessageTemplateLinkSection
  },
  props: {
    templateData: {
      type: Object,
      required: true
    },
    fieldsMaxLength: {
      type: Object,
      required: true
    }
  },
  methods: {
    onTreatmentCreatedFieldInput(eventValue) {
      this.$emit('field-input', eventValue);
    },
    onTreatmentCreatedFieldChange(eventValue) {
      this.$emit('field-change', eventValue);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/message-templates/email-message-templates';
</style>
